import { combineReducers } from "redux";
import { connectRouter } from 'connected-react-router'
import user from "./User";
import form from "./Form";
import assays from "./Assays";
import addToCart from "./AddToCart";

const rootReducer = history => combineReducers({
  router: connectRouter(history),
  user,
  assays,
  addToCart,
  form
});

export default rootReducer;
